import { render } from "./BuyCars.vue?vue&type=template&id=00ac7054"
import script from "./BuyCars.vue?vue&type=script&lang=js"
export * from "./BuyCars.vue?vue&type=script&lang=js"

import exportComponent from "G:\\VUE\\waimao518_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__